// extracted by mini-css-extract-plugin
export default {"root":"NotificationBell_root__wWJtz","badge":"NotificationBell_badge__ktWkO"};